// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"747":"278ab6f8","785":"987da41d","825":"0fb5e89e","894":"e4450cb5"}[chunkId] + ".chunk.css";
};